exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "footer{padding:1em;color:#fff;background-color:#f0f8ff;opacity:.9;filter:(opacity=50);clear:left;text-align:center;width:100%;bottom:0;position:fixed}footer div a{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-3e05aa09","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Footer.vue
// module id = 337
// module chunks = 0